import { render, staticRenderFns } from "./PaymentPurchasePage.vue?vue&type=template&id=25cd488c&scoped=true&"
import script from "./PaymentPurchasePage.vue?vue&type=script&lang=ts&"
export * from "./PaymentPurchasePage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentPurchasePage.vue?vue&type=style&index=0&id=25cd488c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd488c",
  null
  
)

export default component.exports